import axios from "axios";

const axiosAuthorised = axios.create();

axiosAuthorised.interceptors.request.use(async (config) => {
        const token = sessionStorage.getItem('ROCP_token');

        config.headers = {
            'Content-Type': 'application/json; charset=utf-8',
            ...config.headers
        }

        if(config.params && config.params.DEV_OVERRIDE) {
            config.headers = {
                ...config.headers,
                'IPM-Dev-Override': `${process.env.REACT_APP_DEV_OVERRIDE_SLUG}`
            }
        }

        delete config.params['DEV_OVERRIDE'];

        if(token) {
            config.headers = {
                ...config.headers,
                'Authorization': `Bearer ${JSON.parse(token)}`
            }
        } else {
            return Promise.reject('No Authorisation Token');
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    });

axiosAuthorised.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;

    if (error.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;

        const token = sessionStorage.getItem('ROCP_token');

        if(token) {
            axiosAuthorised.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(token);
        }

        return axiosAuthorised(originalRequest);
    }

    return Promise.reject(error);
});

export default axiosAuthorised

export const DEV_OVERRIDE_HEADER = { params: { DEV_OVERRIDE: false } };
